module.exports = __webpack_public_path__ + "static/supriya-8ced2ec13a71e91d519bcc6c195bc7a7.png";